import React from "react";

export default function Empty({ icon: Icon, title, body, cta }) {
  return (
    <div className="border border-dashed border-gray-300 bg-white rounded-md p-10 text-center">
      {Icon && (
        <div className="mx-auto w-12 h-12 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center mb-4">
          <Icon className="w-6 h-6" />
        </div>
      )}
      <h3 className="font-display text-2xl text-[#0B1038] tracking-tight">
        {title}
      </h3>
      {body && (
        <p className="mt-2 text-gray-600 max-w-md mx-auto text-sm leading-relaxed">
          {body}
        </p>
      )}
      {cta && <div className="mt-5">{cta}</div>}
    </div>
  );
}
